import { NotificationTrigger } from '@makyoapp/makyo-sdk/models/Notifications'
import { NotificationACL, NotificationType } from '@makyoapp/makyo-sdk/models/User'
import {
  getNotificationCategory,
  getNotificationLabel,
  getNotificationTrigger,
  NotificationCategory,
  NotificationLabel,
  NotificationSettingsAdapter,
} from '@makyoapp/makyo-common'

const NotificationKeys = [NotificationType.Email, NotificationType.Push]

/**
 * build notification value by pushing a value of email | push
 * to the notification and return the notification
 *
 * @param notification
 * @param values
 */
export const buildValues = (notification: NotificationTrigger, values: NotificationACL): NotificationType[] => {
  const data: NotificationType[] = []
  // notification type is email | push
  NotificationKeys.forEach((notificationType) => {
    const valType = values[notificationType]
    if (valType?.[notification]) {
      data.push(notificationType)
    }
  })

  return data
}

/**
 * rebuild notification values by looping ['email', 'push']
 * remove value if not exist, add value if exist
 *
 * @param notification
 * @param notificationTypes
 * @param rules
 */
export const rebuildNotificationValues = (
  notification: NotificationTrigger,
  notificationTypes: NotificationType[] = [],
  rules: NotificationACL
) => {
  NotificationKeys.forEach((notificationType) => {
    if (rules) {
      const rnt = rules[notificationType]
      if (rnt) {
        rnt[notification] = notificationTypes.includes(notificationType)
      }
    }
  })
}

/**
 * get notification values by walking the array values of
 * `NotificationACL` and push it to the `NotificationSettingsAdapter[]`
 */
export const getNotificationValues = (values?: NotificationACL): NotificationSettingsAdapter[] => {
  const arr: NotificationSettingsAdapter[] = []

  if (typeof values === 'object') {
    for (const v of Object.values(values)) {
      if (v !== undefined) {
        for (const t of Object.keys(v)) {
          if (t) {
            const tr = t as NotificationTrigger
            if (!getNotificationLabel(tr)) {
              //
            }
            if (!getNotificationCategory(tr)) {
              //
            }

            let cat: NotificationCategory | undefined | string = getNotificationCategory(tr)
            //cat = getNotificationCategory(tr)?.toString()
            cat = cat === undefined ? 'Misc' : cat.toString()

            const label = getNotificationLabel(tr)
            if (label) {
              const catIdx = arr.findIndex((ct) => ct?.label === cat)
              if (catIdx !== -1) {
                arr[catIdx].checks[label] = buildValues(tr, values)
              } else {
                arr.push({
                  label: cat,
                  checks: {
                    [label]: buildValues(tr, values),
                  },
                })
              }
            }
          }
        }
      }
    }
  }
  return arr
}

/**
 * rebuild notification acl from
 * `NotificationACL` to `NotificationSettingsAdapter[]`
 */
export const rebuildNotificationsACL = (
  nextValues: NotificationSettingsAdapter[],
  rules: NotificationACL
): NotificationACL => {
  const acl = { ...rules } as NotificationACL

  if (acl) {
    for (let i = 0; i < nextValues.length; i++) {
      const notif = nextValues[i]
      for (const label of Object.keys(notif.checks)) {
        const tr = getNotificationTrigger(label as NotificationLabel)
        if (tr) {
          rebuildNotificationValues(tr, notif.checks[label as NotificationLabel], acl)
        } else {
          //
        }
      }
    }
  }

  return acl
}
